import React from 'react';
import { cn } from '../../../utils/responsive';
import { Order } from '../types';

export const StatusBadge: React.FC<{ status: Order['status'] }> = ({ status }) => {
    const config = {
        pending: { label: 'รอดำเนินการ', className: 'bg-yellow-100 text-yellow-700 border-yellow-200 dark:bg-amber-900/30 dark:text-amber-400 dark:border-amber-800' },
        paid: { label: 'ชำระแล้ว', className: 'bg-emerald-100 text-emerald-700 border-emerald-200 dark:bg-emerald-900/30 dark:text-emerald-400 dark:border-emerald-800' },
        printed: { label: 'ปริ้นแล้ว', className: 'bg-blue-100 text-blue-700 border-blue-200 dark:bg-blue-900/30 dark:text-blue-400 dark:border-blue-800' },
        shipped: { label: 'จัดส่งแล้ว', className: 'bg-purple-100 text-purple-700 border-purple-200 dark:bg-purple-900/30 dark:text-purple-400 dark:border-purple-800' },
        delivered: { label: 'ส่งสำเร็จ', className: 'bg-green-100 text-green-700 border-green-200 dark:bg-green-900/30 dark:text-green-400 dark:border-green-800' },
    };

    const { label, className } = config[status] || config.pending;

    return (
        <span className={cn(
            'inline-flex items-center gap-1 px-2.5 py-1 rounded-full text-xs font-medium border',
            className
        )}>
            {label}
        </span>
    );
};
